import React from 'react';
import DataTable from 'react-data-table-component';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import './CustomTable.css';

const CustomTable = ({
  columns,
  data,
  totalRows,
  onChangePage,
  onChangeRowsPerPage,
  isLoading,
  expandableRowsComponent,
  currentPage,
  perPage,
}) => {
  const LoadingSpinner = () => (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      highlightOnHover
      pointerOnHover
      responsive
      expandableRows={!!expandableRowsComponent}
      expandableRowsComponent={expandableRowsComponent}
      expandableIcon={{
        collapsed: <FaChevronRight />,
        expanded: <FaChevronDown />
      }}
      progressPending={isLoading}
      progressComponent={<LoadingSpinner />}
      noDataComponent={<div className="no-data">No data found</div>}
      paginationPerPage={perPage}
      paginationDefaultPage={currentPage}
    />
  );
};

export default CustomTable;